import axios from "axios";


import { ApiResponse } from "../models/ApiResponse.model";
import {
  Term,
  Social,
  Area,
  Component,
  SupportRequest,
} from "../models/General.model";

class GeneralService {
  public async GetPhoneCountries(): Promise<ApiResponse<any>> {
    const response = await axios.get(`General/GetCountries`);
    return response?.data;
  }

  public async GetTerms(): Promise<ApiResponse<Term[]>> {
    const response = await axios.get(`General/GetCustomerTerms`);
    return response?.data;
  }

  public async GetSocials(): Promise<ApiResponse<Social>> {
    const response = await axios.get(`General/GetSocial`);
    return response?.data;
  }

  public async GetAboutUs(): Promise<ApiResponse<Term[]>> {
    const response = await axios.get(`General/GetAboutUs`);
    return response?.data;
  }

  public async GetAllAreas(countryId?: number): Promise<ApiResponse<Area[]>> {
    const response = await axios.get(`General/AllAreas`, {
      params: { countryId },
    });
    return response?.data;
  }

  public async ContactUs(data: any): Promise<ApiResponse<any>> {
    const response = await axios.post(`General/PartnerContactUs`, data);
    return response?.data;
  }

  public async GetComponent(
    componentType: string,
  ): Promise<ApiResponse<Component>> {
    const response = await axios.get(`/General/GetComponent/${componentType}`);
    return response.data;
  }

  public async GetComponentById(
    componentType: string,
    id: number,
  ): Promise<ApiResponse<Component>> {
    const response = await axios.get(
      `/General/GetComponent/${componentType}/${id}`,
    );
    return response.data;
  }

  public async AddSupport(
    type: string,
    data: SupportRequest,
  ): Promise<ApiResponse<any>> {
    const response = await axios.post(`/General/AddSupport/${type}`, data);
    return response.data;
  }

  public async CreateArea(data: Omit<Area, "id">): Promise<ApiResponse<Area>> {
    const response = await axios.post(`General/Area`, data);
    return response.data;
  }

  public async UpdateArea(data: Area): Promise<ApiResponse<Area>> {
    const response = await axios.put(`General/Area/${data.id}`, data);
    return response.data;
  }

  public async DeleteArea(id: number): Promise<ApiResponse<any>> {
    const response = await axios.delete(`General/Area/${id}`);
    return response.data;
  }
}

export default new GeneralService();
